import React, { useState, forwardRef, useEffect } from 'react';
import ReceiptLogo from 'Components/Logo/ReceiptLogo';
import {
    Button,
    Dialog,
    DialogContent,
    DialogActions,
    DialogContentText,
    DialogTitle,
    Slide,
    Box
} from '@material-ui/core';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { Grid } from '@material-ui/core';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import CommonPrint from 'Components/Print/CommonPrint';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import NSDL_BANK_LOGO from 'Assets/Images/NSDL_BANK_LOGO.png';
import jsPDF from 'jspdf';
import { LOGO_URL, CLIENT_NAME, LOGO_WIDTH } from 'Config';

const StyledTableCell = withStyles((theme) => ({
    body: {
        fontSize: 16,
        fontWeight: 'bold'
    }
}))(TableCell);

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export function DMTTransactionPrint({
    isOpen,
    title,
    request,
    positiveButtonTitle,
    positiveButtonClick,
    negativeButtonTitle,
    negativeButtonClick
}) {
    const [open, setOpen] = useState(isOpen);
    const classes = commonStyle();
    const handleNegativeButtonClick = () => {
        setOpen(false);
        negativeButtonClick();
    };
    const handlePositiveA4ButtonClick = () => {
        let pageSize = 'A4';
        CommonPrint(pageSize);
        positiveButtonClick(request);
    };
    const handlePositiveA5ButtonClick = () => {
        let pageSize = 'A5';
        CommonPrint(pageSize);
        positiveButtonClick(request);
    };

    const handlePositiveDownlaodButtonClick = () => {
        const printElement = document.getElementById('DialogPrint');
        const originalHTML = printElement.innerHTML;
        // Replace currency symbols with ASCII equivalents temporarily
        const sanitizedHTML = originalHTML
            .replace(/₹/g, 'Rs.')
            .replace(/[^\x00-\x7F]/g, ''); // Remove all non-ASCII characters
        printElement.innerHTML = sanitizedHTML;
        // Rest of your PDF generation code...
        const doc = new jsPDF({
            orientation: 'portrait',
            unit: 'pt',
            format: 'a4',
            putOnlyUsedFonts: true,
            floatPrecision: 16
        });
        doc.html(printElement, {
            callback: function (doc) {
                // Restore original HTML
                printElement.innerHTML = originalHTML;
                // Add footer text
                doc.setTextColor(0, 0, 0);
                doc.setFontSize(10);
                doc.text(
                    'This is a system-generated receipt.',
                    40,
                    doc.internal.pageSize.height - 40
                );
                doc.save('DMT_Receipt.pdf');
            },
            x: 10,
            y: 40,
            width: 500,
            windowWidth: 500,
            html2canvas: {
                scale: 0.8,
                useCORS: true,
                backgroundColor: '#FFFFFF',
                allowTaint: false,
                letterRendering: true
            }
        });
    };

    let data = request.List;
    const getStatusColor = (status) => {
        switch (status?.toLowerCase()) {
            case 'success':
                return 'green';
            case 'failed':
            case 'failure':
                return 'red';
            case 'pending':
            case 'process':
                return 'orange';
            default:
                return 'orange';
        }
    };

    return (
        <Dialog
            classes={{ paperFullScreen: 'prePrint' }}
            open={open}
            onClose={() => {
                setOpen(false);
                negativeButtonClick(false);
            }}
            TransitionComponent={Transition}
        >
            <DialogTitle
                id="alert-dialog-title"
                className={classes.title}
                style={{
                    backgroundColor: getStatusColor(data?.[0]?.Status),
                    color: '#fff'
                }}
            >
                {title}
            </DialogTitle>

            <DialogContent>
                <DialogContentText id="DialogPrint">
                    <PrintDetails request={request} />
                </DialogContentText>
            </DialogContent>
            <Box
                style={{
                    position: 'relative',
                    width: '100%',
                    zIndex: 0,
                    marginBottom: '16px',
                    padding: '10px',
                    backgroundColor: '#ccc',
                    color: '#000',
                    fontSize: '10px',
                    textAlign: 'center'
                }}
            >
                This is a system-generated receipt.
            </Box>
            <DialogActions displayPrint="none">
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={3} lg={3}>
                        <Button
                            onClick={handleNegativeButtonClick}
                            className={classes.CustomSecondaryButtonStylePopup}
                        >
                            {negativeButtonTitle
                                ? negativeButtonTitle
                                : 'Close'}
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={12} md={3} lg={3}>
                        <Button
                            onClick={handlePositiveDownlaodButtonClick}
                            className={classes.CustomPrimaryButtonStylePopup}
                        >
                            {positiveButtonTitle
                                ? positiveButtonTitle
                                : 'Download'}
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={12} md={3} lg={3}>
                        <Button
                            onClick={handlePositiveA4ButtonClick}
                            className={classes.CustomPrimaryButtonStylePopup}
                        >
                            {positiveButtonTitle
                                ? positiveButtonTitle
                                : 'A4 Print'}
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={12} md={3} lg={3}>
                        <Button
                            onClick={handlePositiveA5ButtonClick}
                            className={classes.CustomPrimaryButtonStylePopup}
                        >
                            {positiveButtonTitle
                                ? positiveButtonTitle
                                : 'A5Print'}
                        </Button>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
    );
}

const PrintDetails = (request) => {
    let data = request.request;
    const NsdlBankLogo = () => {
        return <img src={NSDL_BANK_LOGO} width={200} alt="DMT" />;
    };

    const ReceiptLogo = () => {
        return <img src={logoURL} width={100} alt="DMT" />;
    };
    let transaction = data.List;
    const getStatusColor = (status) => {
        switch (status?.toLowerCase()) {
            case 'success':
                return 'green';
            case 'failed':
            case 'failure':
                return 'red';
            case 'pending':
            case 'process':
                return 'orange';
            default:
                return 'orange';
        }
    };

    useEffect(() => {
        fetchCName();

        fetchLogoURL();
    }, []);

    const [logoURL, setLogoURL] = useState('');

    async function fetchLogoURL() {
        setLogoURL(await LOGO_URL());
    }

    const [cName, setCName] = useState('');
    async function fetchCName() {
        setCName(await CLIENT_NAME());
    }
    return (
        <Grid item xs={12}>
            <Grid item xs={12}>
                <Box
                    style={{
                        border: '2px solid #000',
                        padding: '5px',
                        marginTop: '5px',
                        marginLeft: '5px',
                        backgroundColor: '#fff',
                        width: '450px',
                        minHeight: '700px',
                        height: 'auto',
                        position: 'relative',
                        paddingTop: '15px'
                    }}
                >
                    <Grid
                        style={{
                            display: 'flex',
                            justifyContent: 'space-around',
                            flex: 'auto'
                        }}
                    >
                        <NsdlBankLogo />
                        <ReceiptLogo />
                    </Grid>
                    <TableContainer>
                        <h4 style={{ textAlign: 'center', padding: '10px 0' }}>
                            {/* Transaction Details */}
                        </h4>

                        {transaction.map((trans, index) => (
                            <TableContainer key={index}>
                                <Table>
                                    <TableBody>
                                        <TableRow>
                                            <StyledTableCell
                                                style={{
                                                    padding: '8px 0 8px 15px'
                                                }}
                                            >
                                                Transaction Status
                                            </StyledTableCell>
                                            <StyledTableCell
                                                style={{
                                                    padding: '8px 0 8px 15px'
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        fontSize: '14px',
                                                        color: getStatusColor(
                                                            trans.Status
                                                        ),
                                                        fontWeight: 'normal'
                                                    }}
                                                >
                                                    <b>
                                                        {' '}
                                                        {trans.Status ?? 'NA'}
                                                    </b>
                                                </span>
                                            </StyledTableCell>
                                        </TableRow>

                                        <TableRow>
                                            <StyledTableCell
                                                style={{
                                                    padding: '8px 0 8px 15px'
                                                }}
                                            >
                                                Date & Time
                                            </StyledTableCell>
                                            <StyledTableCell
                                                style={{
                                                    padding: '8px 0 8px 15px'
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        fontSize: '14px',
                                                        color: '#000',
                                                        fontWeight: 'normal'
                                                    }}
                                                >
                                                    {trans.DOC ?? 'NA'}
                                                </span>
                                            </StyledTableCell>
                                        </TableRow>

                                        <TableRow>
                                            <StyledTableCell
                                                style={{
                                                    padding: '8px 0 8px 15px'
                                                }}
                                            >
                                                Product Name
                                            </StyledTableCell>
                                            <StyledTableCell
                                                style={{
                                                    padding: '8px 0 8px 15px'
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        fontSize: '14px',
                                                        color: '#000',
                                                        fontWeight: 'normal'
                                                    }}
                                                >
                                                    {data.ServiceName ?? 'NA'}
                                                </span>
                                            </StyledTableCell>
                                        </TableRow>
                                        <TableRow>
                                            <StyledTableCell
                                                style={{
                                                    padding: '8px 0 8px 15px'
                                                }}
                                            >
                                                Service Name
                                            </StyledTableCell>
                                            <StyledTableCell
                                                style={{
                                                    padding: '8px 0 8px 15px'
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        fontSize: '14px',
                                                        color: '#000',
                                                        fontWeight: 'normal'
                                                    }}
                                                >
                                                    {data.ProductName ?? 'NA'}
                                                </span>
                                            </StyledTableCell>
                                        </TableRow>

                                        <TableRow>
                                            <StyledTableCell
                                                style={{
                                                    padding: '8px 0 8px 15px'
                                                }}
                                            >
                                                Payment Mode
                                            </StyledTableCell>
                                            <StyledTableCell
                                                style={{
                                                    padding: '8px 0 8px 15px'
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        fontSize: '14px',
                                                        color: '#000',
                                                        fontWeight: 'normal'
                                                    }}
                                                >
                                                    {data.PaymentType ?? 'NA'}
                                                </span>
                                            </StyledTableCell>
                                        </TableRow>
                                        <TableRow>
                                            <StyledTableCell
                                                style={{
                                                    padding: '8px 0 8px 15px'
                                                }}
                                            >
                                                Amount {'(₹)'}
                                            </StyledTableCell>
                                            <StyledTableCell
                                                style={{
                                                    padding: '8px 0 8px 15px'
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        fontSize: '14px',
                                                        color: '#000',
                                                        fontWeight: 'normal'
                                                    }}
                                                >
                                                    {trans.Amount ?? '0'}
                                                </span>
                                            </StyledTableCell>
                                        </TableRow>
                                        <TableRow>
                                            <StyledTableCell
                                                style={{
                                                    padding: '8px 0 8px 15px'
                                                }}
                                            >
                                                Charge {'(₹)'}
                                            </StyledTableCell>
                                            <StyledTableCell
                                                style={{
                                                    padding: '8px 0 8px 15px'
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        fontSize: '14px',
                                                        color: '#000',
                                                        fontWeight: 'normal'
                                                    }}
                                                >
                                                    {data.TotalCharge ?? '0'}
                                                </span>
                                            </StyledTableCell>
                                        </TableRow>
                                        <TableRow>
                                            <StyledTableCell
                                                style={{
                                                    padding: '8px 0 8px 15px'
                                                }}
                                            >
                                                GST {'(₹)'}
                                            </StyledTableCell>
                                            <StyledTableCell
                                                style={{
                                                    padding: '8px 0 8px 15px'
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        fontSize: '14px',
                                                        color: '#000',
                                                        fontWeight: 'normal'
                                                    }}
                                                >
                                                    {data.GST ?? '0'}
                                                </span>
                                            </StyledTableCell>
                                        </TableRow>
                                        <TableRow>
                                            <StyledTableCell
                                                style={{
                                                    padding: '8px 0 8px 15px'
                                                }}
                                            >
                                                Total Amount {'(₹)'}
                                            </StyledTableCell>
                                            <StyledTableCell
                                                style={{
                                                    padding: '8px 0 8px 15px'
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        fontSize: '14px',
                                                        color: '#000',
                                                        fontWeight: 'normal'
                                                    }}
                                                >
                                                    {data.DebitAmount}
                                                </span>
                                            </StyledTableCell>
                                        </TableRow>
                                        <TableRow>
                                            <StyledTableCell
                                                style={{
                                                    padding: '8px 0 8px 15px'
                                                }}
                                            >
                                                Transaction ID
                                            </StyledTableCell>
                                            <StyledTableCell
                                                style={{
                                                    padding: '8px 0 8px 15px'
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        fontSize: '14px',
                                                        color: '#000',
                                                        fontWeight: 'normal'
                                                    }}
                                                >
                                                    {data.TransactionID ?? '0'}
                                                </span>
                                            </StyledTableCell>
                                        </TableRow>
                                        <TableRow>
                                            <StyledTableCell
                                                style={{
                                                    padding: '8px 0 8px 15px'
                                                }}
                                            >
                                                RRN
                                            </StyledTableCell>
                                            <StyledTableCell
                                                style={{
                                                    padding: '8px 0 8px 15px'
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        fontSize: '14px',
                                                        color: '#000',
                                                        fontWeight: 'normal'
                                                    }}
                                                >
                                                    {trans.UTRNumber}
                                                </span>
                                            </StyledTableCell>
                                        </TableRow>
                                        <TableRow>
                                            <StyledTableCell
                                                style={{
                                                    padding: '8px 0 8px 15px'
                                                }}
                                            >
                                                Sender Mobile Number
                                            </StyledTableCell>
                                            <StyledTableCell
                                                style={{
                                                    padding: '8px 0 8px 15px'
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        fontSize: '14px',
                                                        color: '#000',
                                                        fontWeight: 'normal'
                                                    }}
                                                >
                                                    {data.SenderNo}
                                                </span>
                                            </StyledTableCell>
                                        </TableRow>
                                        <TableRow>
                                            <StyledTableCell
                                                style={{
                                                    padding: '8px 0 8px 15px'
                                                }}
                                            >
                                                Beneficiary Mobile Number
                                            </StyledTableCell>
                                            <StyledTableCell
                                                style={{
                                                    padding: '8px 0 8px 15px'
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        fontSize: '14px',
                                                        color: '#000',
                                                        fontWeight: 'normal'
                                                    }}
                                                >
                                                    {data.MobileNumber}
                                                </span>
                                            </StyledTableCell>
                                        </TableRow>
                                        <TableRow>
                                            <StyledTableCell
                                                style={{
                                                    padding: '8px 0 8px 15px'
                                                }}
                                            >
                                                Beneficiary Bank Name
                                            </StyledTableCell>
                                            <StyledTableCell
                                                style={{
                                                    padding: '8px 0 8px 15px'
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        fontSize: '14px',
                                                        color: '#000',
                                                        fontWeight: 'normal'
                                                    }}
                                                >
                                                    {data.Bank}
                                                </span>
                                            </StyledTableCell>
                                        </TableRow>
                                        <TableRow>
                                            <StyledTableCell
                                                style={{
                                                    padding: '8px 0 8px 15px'
                                                }}
                                            >
                                                Beneficiary Name
                                            </StyledTableCell>
                                            <StyledTableCell
                                                style={{
                                                    padding: '8px 0 8px 15px'
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        fontSize: '14px',
                                                        color: '#000',
                                                        fontWeight: 'normal'
                                                    }}
                                                >
                                                    {data.BeneName}
                                                </span>
                                            </StyledTableCell>
                                        </TableRow>
                                        <TableRow>
                                            <StyledTableCell
                                                style={{
                                                    padding: '8px 0 8px 15px'
                                                }}
                                            >
                                                Beneficiary A/C Number
                                            </StyledTableCell>
                                            <StyledTableCell
                                                style={{
                                                    padding: '8px 0 8px 15px'
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        fontSize: '14px',
                                                        color: '#000',
                                                        fontWeight: 'normal'
                                                    }}
                                                >
                                                    {data.ConsumerNumber}
                                                </span>
                                            </StyledTableCell>
                                        </TableRow>
                                        <TableRow>
                                            <StyledTableCell
                                                style={{
                                                    padding: '8px 0 8px 15px'
                                                }}
                                            >
                                                Beneficiary IFSC
                                            </StyledTableCell>
                                            <StyledTableCell
                                                style={{
                                                    padding: '8px 0 8px 15px'
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        fontSize: '14px',
                                                        color: '#000',
                                                        fontWeight: 'normal'
                                                    }}
                                                >
                                                    {data.IFSC}
                                                </span>
                                            </StyledTableCell>
                                        </TableRow>
                                        {trans.Status.toLowerCase() ==
                                            'failure' && (
                                            <TableRow>
                                                <StyledTableCell
                                                    style={{
                                                        padding:
                                                            '8px 0 8px 15px'
                                                    }}
                                                >
                                                    Failure Reason
                                                </StyledTableCell>
                                                <StyledTableCell
                                                    style={{
                                                        padding:
                                                            '8px 0 8px 15px'
                                                    }}
                                                >
                                                    <span
                                                        style={{
                                                            fontSize: '14px',
                                                            color: '#000',
                                                            fontWeight: 'normal'
                                                        }}
                                                    >
                                                        {data.Description}
                                                    </span>
                                                </StyledTableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        ))}
                    </TableContainer>
                </Box>
            </Grid>
        </Grid>
    );
};
